import {
    GET_ALL_POD_STYLE_WISE_REQUEST,
    GET_ALL_POD_STYLE_WISE_SUCCESS,
    GET_ALL_POD_STYLE_WISE_ERROR,

} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";

///Post Bussiness dashboard
export const getPodBookedReport = (token, values) => (dispatch) => {
    dispatch({ type: GET_ALL_POD_STYLE_WISE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/podstylewise`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { ...values },
    })
        .then((response) => {
            return dispatch({
                type: GET_ALL_POD_STYLE_WISE_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            dispatch({
                type: GET_ALL_POD_STYLE_WISE_ERROR,
                payload: [],
            });
        });
};
